import copyrightImg2 from "../assets/images/Travel Agency License Registration in Bangladesh.png";
import Faq from "./Faq";
import Meta from "./Meta";

export default function TravelAgency() {
const faqItems = [
  {
    title: "What is a Travel Agency License in Bangladesh?",
    content: (
      <strong>
        A Travel Agency License is an official permit issued by the Ministry of Civil Aviation and Tourism (MoCAT) in Bangladesh,
        allowing a business to legally operate as a travel agency. This includes offering services like ticketing,
        tour packages, visa processing, hotel booking, and Hajj/Umrah packages.
      </strong>
    ),
  },
  {
    title: "Who needs a Travel Agency License?",
    content: (
      <strong>
        Any individual or company intending to offer travel-related services — whether domestic or international —
        must obtain a travel agency license. Operating without a valid license is illegal and can result in penalties.
      </strong>
    ),
  },
  {
    title: "What are the types of travel agency license in Bangladesh?",
    content: (
      <strong>
        There are typically two types of licenses:<br />
        - **Category A** – For agencies operating both domestic and international ticketing, including Hajj/Umrah<br />
        - **Category B** – For domestic ticketing and tour operations only<br />
        The license category depends on the scope of your services and your application to the licensing authority.
      </strong>
    ),
  },
  {
    title: "Which authority issues travel agency license?",
    content: (
      <strong>
        The Civil Aviation Authority of Bangladesh (CAAB), under the Ministry of Civil Aviation and Tourism (MoCAT),
        is responsible for issuing and renewing travel agency licenses. Applications are typically submitted through
        the Bangladesh Parjatan Corporation (BPC) or related regional offices.
      </strong>
    ),
  },
  {
    title: "What documents are required for a travel agency license?",
    content: (
      <strong>
        Required documents usually include:<br />
        - Application form<br />
        - Trade license<br />
        - TIN certificate<br />
        - National ID/Passport of owner or directors<br />
        - Bank solvency certificate<br />
        - Office rent deed or ownership documents<br />
        - Police clearance (for Hajj/Umrah license)<br />
        - MOA & Incorporation Certificate (for limited companies)
      </strong>
    ),
  },
  {
    title: "How long does it take to get the license?",
    content: (
      <strong>
        On average, it takes around **30–45 working days** to complete the full application and approval process,
        depending on the category, documentation, and verification by authorities.
      </strong>
    ),
  },
  {
    title: "Is license renewal required?",
    content: (
      <strong>
        Yes, travel agency licenses must be renewed annually. The renewal process includes fee payment, updated documents,
        and compliance with current government policies. Late renewal may result in penalties or cancellation.
      </strong>
    ),
  },
];


  return (
    <>
      <Meta
        title="Travel Agency Licenses in Bangladesh | Travel Agency License "
        description="To legally operate a travel agency in Bangladesh, you must complete the licensing process as per the regulations set by the Ministry of Civil Aviation."
        // image={environment_og_Img}
        keywords="Travel Agency Licenses, Travel Agency License in Bangladesh, Travel Agency,  Tour and Travel Agency, Tour Agency License"
      />
      <div className="container-fluid hero-header bg-light mb-3">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h1
                className="display-4 mb-3 animated slideInDown"
                style={{ fontSize: "40px" }}
              >
                Travel Agency License
              </h1>
            </div>
            <div className="col-lg-6 animated fadeIn">
              <img
                className="img-fluid animated pulse infinite"
                style={{ animationDuration: "3s" }}
                src={"/img/jk-associates-travel-agency.png"}
                alt="Environmental"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl ">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>Travel Agency License in Bangladesh</b>
          </p>
          <p>
            To establish a travel agency in Bangladesh, you must adhere to
            specific legal and regulatory requirements to ensure compliance and
            legitimacy. Below is a comprehensive guide outlining the necessary
            steps and considerations
          </p>
        </div>
      </div>
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6  ">
              <img
                className="img-fluid"
                src={copyrightImg2}
                alt="Copyright-Registration-Process"
              />
            </div>
            <div className="col-lg-6  ">
              <div className="h-100">
                <p className="color-text fs-5 mb-4">Business Registration:</p>
                <ul>
                  <li>
                    <b>Company Registration:</b> Register your business with the
                    Registrar of Joint Stock Companies and Firms (RJSC) to
                    obtain legal recognition.
                  </li>
                  <li>
                    <b>Trade License:</b> Obtain a trade license from the local
                    City Corporation or Union Parishad to operate legally.
                  </li>
                  <li>
                    <b>Tax Identification Number (TIN):</b> Secure a TIN from
                    the National Board of Revenue (NBR) for tax compliance.
                  </li>
                  <li>
                    <b>Value Added Tax (VAT) Registration:</b> If applicable,
                    register for VAT with the NBR to meet tax obligations.
                  </li>
                </ul>

                <p className="color-text fs-5 mb-4">Office Requirements:</p>
                <ul>
                  <li>
                    <b>Physical Office Space:</b> Maintain an office that meets
                    International Air Transport Association (IATA) standards.
                  </li>
                  <li>
                    <b>Signage:</b> Display a signboard with the agency's name,
                    address, and registration number.
                  </li>
                </ul>

                <p className="color-text fs-5 mb-4">
                  Ministry of Civil Aviation and Tourism Registration:
                </p>
                <ul>
                  <li>
                    <b>Application Submission:</b> Submit an application with
                    required documents such as trade license, TIN certificate,
                    office details, and business registration proof.
                  </li>
                  <li>
                    <b>Regulatory Compliance:</b> Ensure compliance with the
                    Bangladesh Travel Agency (Registration and Control) Act,
                    2013.
                  </li>
                </ul>

                <p className="color-text fs-5 mb-4">
                  IATA Accreditation (Optional but Beneficial):
                </p>
                <ul>
                  <li>
                    <b>Eligibility:</b> Maintain a valid business license and an
                    office that meets IATA standards.
                  </li>
                  <li>
                    <b>Examination:</b> Pass the IATA exam with a minimum score
                    of 80%.
                  </li>
                  <li>
                    <b>Application:</b> Apply online for an IATA number to book
                    flights directly for clients.
                  </li>
                </ul>

                <p className="color-text fs-5 mb-4">
                  Membership in Professional Associations:
                </p>
                <ul>
                  <li>
                    <b>Association of Travel Agents of Bangladesh (ATAB):</b>{" "}
                    Consider joining ATAB, which offers industry benefits and
                    representation.
                  </li>
                </ul>

                <p className="color-text fs-5 mb-4">
                  Compliance and Ethical Practices:
                </p>
                <ul>
                  <li>
                    <b>Service Commitment:</b> Provide promised services and
                    avoid fraudulent activities.
                  </li>
                  <li>
                    <b>Scope of Services:</b> Operate within the authorized
                    scope of your travel agency license.
                  </li>
                  <li>
                    <b>Client Relations:</b> Ensure transparent dealings and
                    avoid harassment.
                  </li>
                  <li>
                    <b>Regulatory Cooperation:</b> Assist authorities during
                    inspections or investigations.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-xxl py-0">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>
            Travel Agency License Registration Process in Bangladesh.
            </b>
          </p>
          <p>
          To legally operate a travel agency in Bangladesh, you must complete the licensing process as per the regulations set by the Ministry of Civil Aviation and Tourism. Below are the detailed steps and requirements
          </p>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>
            Application Fee: BDT 5,000/- to be deposited under Code: 1-5301-0001-1816 or 1422202
            </span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Registration Fee: BDT 50,000/- to be deposited under the same code</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>VAT (Value Added Tax): BDT 7,500/- to be deposited under Code: 1141101.</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Fill out the designated online application form correctly.</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Submit the required documents as outlined below.</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Treasury Challan Receipt for the application fee (BDT 5,000/-)</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Certified Copy of the Updated Trade License</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>
            Certified Copy of the TIN Certificate
            </span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>
            Proof of Business Address
            </span>
           
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>If it is a partnership firm, submit the Partnership Agreement.</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Affidavit on BDT 300 Non-Judicial Stamp Paper</span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>
            Bank Solvency Certificate showing a minimum balance of BDT 10 lakh (1 million taka)
            </span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>
            Photographs of the Office Premises
            </span>
          </div>
          <div className="d-flex align-items-center mb-2">
            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
            <span>Original Treasury Challan Receipt for the Registration Fee and VAT</span>
          </div>
        </div>
      </div>
       <div className="container py-5 my-0">
                <h2 className="color-text text-center mb-4">Travel Agency FAQ</h2>
                <Faq items={faqItems} />
            </div>
    </>
  );
}
